<template>
  <main>
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted playsinline loop class="section__video">
        <source src="@/assets/video/liveshopping.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">Live Shopping Parade</h2>
        <div class="details">
          <p class="description">
            Dalam rangka memeriahkan acara HUT MNC Group ke-32, MNC E-Commerce menyelenggarakan Parade Live Shopping. 
            Parade Live Shopping adalah rangkaian acara live eMShop,
            The F Thing, AladinMall bersama Aladin Travel berdurasi 60menit yang akan dilaksanakan pada tanggal 1-4 
            November 2021 pada pukul 14.00 WIB. 
          </p>
        </div>

        <div class="details">
          <img class="md-image" src="@/assets/images/paradelive.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Periode Live Shopping Parade</div>
          <br>
          <ul>
            <div class="description"><span class="txt-bold">Periode 1 November 2021,</span> eMShop Live Shopping di Instagram <a href="https://www.instagram.com/officialrcti/" target="_blank" class="link">@officialrcti</a> pukul 14.00 WIB</div>
            <li class="description list-block mg-left-35">
              Rangkaian acara berupa Cooking Demo, Sebar Giveaway, Voucher Cashback yang dimeriahkan oleh Firhan Ashari - Runner Up Master Chef Indonesia Season 6. 
            </li>
            <br>
            <div class="description"><span class="txt-bold">Periode 2 November 2021,</span>The F Thing Live Class di Instagram <a href="https://www.instagram.com/officialrcti/" target="_blank" class="link">@officialrcti</a> dan <a href="https://www.instagram.com/thefthingworld/" class="link" target="_blank">@thefthingworld</a> pukul 14.00 WIB</div>
            <li class="description list-block mg-left-35">
              Rangkaian acara berupa Diskon Program Spesial HUT MNC Group untuk Produk-Produk pilihan AladinMall, Flash Sale dan Diskon Hotel Group Archipelago oleh Aladin Travel. 
            </li>
            <br>
            <div class="description"><span class="txt-bold">Periode 3 November 2021,</span>AladinMall bersama AladinTravel Live Sale di Instagram  <a href="https://www.instagram.com/officialrcti/" target="_blank" class="link">@officialrcti</a> pukul 14.00 WIB</div>
            <li class="description list-block mg-left-35">
              Rangkaian acara berupa beauty class Tips & Trick Memilih Produk Kecantikan  yang akan dimeriahkan oleh Fashion & Beauty Influencer Erich Al Amin.
            </li>
            <br>
            <div class="description"><span class="txt-bold">Periode 4 November 2021,</span> MNC E-Commerce akan melakukan Live Shopping bersama di <a href="https://m.rctiplus.com" class="link" target="_blank">RCTI+ </a> pukul 14.00 WIB </div>
            <li class="description list-block mg-left-35">
              Rangkaian acara berupa Cooking Demo oleh Firhan Ashari - Runner Up Master Chef Indonesia Season 6, Sebar Giveaway, Flash Sale dan Promo Spesial Produk lainnya. 
            </li>
          </ul>
        </div>

        <div class="details">
          <div class="font-title">Syarat & Ketentuan</div>
          <br>
          <ul class="mg-left-35">
            <li class="description list-block">Peserta untuk semua umur</li>
            <li class="description list-block">Peserta wajib follow akun Instagram <a href="https://www.instagram.com/emshop_officials/" target="_blank" class="link">@emshop_officials</a>, <a href="https://www.instagram.com/thefthingworld/" class="link" target="_blank">@thefthingworld </a>, <a href="https://www.instagram.com/misteraladin/" class="link" target="_blank">@misteraladin</a> </li>
            <li class="description list-block">Peserta diwajibkan memiliki akun RCTI+ </li>
            <li class="description list-block">Peserta wajib mengikuti salah satu acara untuk mendapatkan Giveaway </li>
            <li class="description list-block">Peserta wajib chat Admin <a href="https://www.instagram.com/emshop_officials/" target="_blank" class="link">@emshop_officials</a>, <a href="https://www.instagram.com/thefthingworld/" class="link" target="_blank">@thefthingworld </a>, <a href="https://www.instagram.com/misteraladin/" class="link" target="_blank">@misteraladin</a> melalui Instagram berupa data diri yang dapat dihubungi untuk mendapatkan kesempatan Giveaway. </li>
          </ul>
        </div>

        <div class="details">
          <div class="font-title">Hadiah Giveaway </div>
          <br>
          <ul class="mg-left-20">
            <div class="txt-bold">eMShop :</div>
            <li class="description list-block mg-left-20">2 set Locknlock Air Fryer Gold Series , 2 set Locknlock 8in1 Knife Set , 3 set Locknlock Tumbler Darbotz , 3 set Oxone Cookie Maker , 3 set Locknlock 6in1 Knife Set , 1 set Oxone Mixing Bowl</li>
            <br>
            <div class="txt-bold">The F Thing :</div>
            <li class="description list-block mg-left-20">Gift Voucher </li>
            <br>
            <div class="txt-bold">AladinMall & AladinTravel :</div>
            <li class="description list-block mg-left-20">Gift Voucher Disc 32% , Flash Sale Disc 100K , Disc Hotel Group Archipelago , Disc Flight</li>
          </ul>
        </div>

        <!-- <div class="details">
          <table>
            <thead>
                <tr>
                    <th>Nama Produk</th>
                    <th>Qty</th>
                    <th>Value</th>
                    <th>Total Value</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                  <td colspan="4">
                    Live 01 Nov 2021 IG @officialrcti 
                  </td>
                </tr>
                <tr>
                    <th scope="row">Locknlock Air Fryer </th>
                    <td>1</td>
                    <td>Rp. 1.799.000</td>
                    <td>Rp. 1.799.000</td>
                </tr>
                <tr>
                    <th scope="row">Locknlock Knife Set </th>
                    <td>2</td>
                    <td>Rp. 399.000</td>
                    <td>Rp. 798.000</td>
                </tr>
                <tr>
                  <th scope="row">Locknlock Darbotz Tumbler</th>
                  <td>3</td>
                  <td>Rp. 399.000</td>
                  <td>Rp. 1.197.000</td>
                </tr>
                <tr>
                  <th scope="row">Oxone Cookie Maker</th>
                  <td>3</td>
                  <td>Rp. 399.000</td>
                  <td>Rp. 1.197.000</td>
                </tr>
                <tr>
                  <td colspan="4">
                    Live 04 Nov 2021 di RCTI+
                  </td>
                </tr>
                <tr>
                  <th scope="row">Locknlock Air Fryer </th>
                  <td>1</td>
                  <td>Rp. 1.799.000</td>
                  <td>Rp. 1.799.000</td>
                </tr>
                <tr>
                  <th scope="row">Oxone Mixing Bowl </th>
                  <td>1</td>
                  <td>Rp. 1.199.000</td>
                  <td>Rp. 1.199.000</td>
                </tr>
                <tr>
                  <th scope="row">Locknlok Colorful Knife Set</th>
                  <td>3</td>
                  <td>Rp. 399.000</td>
                  <td>Rp. 1.197.000</td>
                </tr>
            </tbody>
          </table>
        </div> -->


      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailParadeLive',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>